import * as React from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
  size?: number | null
  color?: string
  circleBorder?: boolean
}

function InstagramIcon({
  title,
  titleId,
  size = 60,
  color = '#fff',
  circleBorder = true,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  const svgProps = {
    viewBox: '0 0 60 60',
    'aria-labelledby': titleId,
    ...props,
  }

  if (size) {
    svgProps.width = size
    svgProps.height = size
  }

  return (
    <svg {...svgProps}>
      {title ? <title id={titleId}>{title}</title> : null}
      <g data-name="Group 436">
        {circleBorder && (
          <g data-name="Ellipse 5" fill="none" stroke={color} strokeWidth={2}>
            <circle cx={30} cy={30} r={30} stroke="none" />
            <circle cx={30} cy={30} r={29} />
          </g>
        )}
        <g data-name="Symbol 1 \u2013 1">
          <path
            data-name="Path 3"
            d="M29.562 19.286a41.585 41.585 0 015.425.151 6.989 6.989 0 012.562.452 5.292 5.292 0 012.562 2.562 6.989 6.989 0 01.452 2.562c0 1.356.151 1.808.151 5.425a41.585 41.585 0 01-.151 5.425 6.989 6.989 0 01-.452 2.562 5.292 5.292 0 01-2.562 2.562 6.989 6.989 0 01-2.562.452c-1.356 0-1.808.151-5.425.151a41.585 41.585 0 01-5.425-.151 6.989 6.989 0 01-2.562-.452 5.292 5.292 0 01-2.562-2.562 6.989 6.989 0 01-.452-2.562c0-1.356-.151-1.808-.151-5.425a41.585 41.585 0 01.151-5.425 6.989 6.989 0 01.452-2.562 5.412 5.412 0 011.056-1.507 2.548 2.548 0 011.507-1.055 6.989 6.989 0 012.562-.452 41.585 41.585 0 015.425-.151m0-2.411a44.525 44.525 0 00-5.576.151 9.3 9.3 0 00-3.315.6 5.9 5.9 0 00-2.412 1.509 5.9 5.9 0 00-1.507 2.411 6.866 6.866 0 00-.6 3.315A44.525 44.525 0 0016 30.437a44.525 44.525 0 00.151 5.576 9.3 9.3 0 00.6 3.315 5.9 5.9 0 001.509 2.411 5.9 5.9 0 002.411 1.507 9.3 9.3 0 003.315.6 44.525 44.525 0 005.576.151 44.525 44.525 0 005.576-.151 9.3 9.3 0 003.315-.6 6.322 6.322 0 003.918-3.918 9.3 9.3 0 00.6-3.315c0-1.507.151-1.959.151-5.576a44.525 44.525 0 00-.151-5.576 9.3 9.3 0 00-.6-3.315 5.9 5.9 0 00-1.507-2.411 5.9 5.9 0 00-2.411-1.507 9.3 9.3 0 00-3.315-.6 44.525 44.525 0 00-5.576-.153m0 6.63a6.82 6.82 0 00-6.932 6.932 6.932 6.932 0 106.932-6.932m0 11.453a4.44 4.44 0 01-4.521-4.521 4.44 4.44 0 014.521-4.521 4.44 4.44 0 014.521 4.521 4.44 4.44 0 01-4.521 4.521M36.8 21.546a1.658 1.658 0 101.658 1.658 1.672 1.672 0 00-1.658-1.658"
            fill={color}
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  )
}

export default InstagramIcon
